export default function Go_Boolean () {
  return (
    <div>
      <h1>Go_Boolean </h1>
      <p>Boolean</p>
    </div>
  );
}